import React from 'react';

const SuccessIcon: React.FC = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="48px"
    height="48px"
    viewBox="0 0 48 48"
    enableBackground="new 0 0 48 48"
    xmlSpace="preserve"
  >
    <g>
      <g>
        <path
          fill="#9B9FA6"
          d="M24,1c12.7,0,23,10.3,23,23S36.7,47,24,47S1,36.7,1,24S11.3,1,24,1 M24,0C10.8,0,0,10.8,0,24
      c0,13.2,10.8,24,24,24c13.2,0,24-10.8,24-24C48,10.8,37.2,0,24,0L24,0z"
        />
      </g>
      <g>
        <polygon fill="#9B9FA6" points="20,32.7 11.6,24.4 12.4,23.6 20,31.3 35.6,15.6 36.4,16.4" />
      </g>
    </g>
  </svg>
);

export default SuccessIcon;
